<template>
 <VDialog
    v-if="isAnotherPassengerDialogDeleteShow"
    :value="isAnotherPassengerDialogDeleteShow"
    width="425"
>
    <VCard
        v-click-outside="closeDialog"
        :loading="isLoading"
        class="p-0 shadow-none border-radius-8 px-4 py-4 position-relative"
    >
    <VCardTitle class="p-0 d-flex justify-content-between align-center position-relative">
        <div>
            <span class="heading-6">
                {{ $t('checkout.anotherPersonDetails.deletePassenger') }}
            </span>
        </div>
      <VBtn
        icon
        class="grey-lighten-4 box-shadow-elevation-6"
        @click="closeDialog"
        >
        <VIcon color="textPrimary">mdi-close</VIcon>
        </VBtn>
    </VCardTitle>
    <VCardText class="p-0 pt-6">
        <div>
            <span class="body-1">{{ $t('checkout.anotherPersonDetails.deletePassengerConfirmation') }}</span>
        </div>
        <span class="body-1 textPrimary--text">{{ getPassengerInfo }}</span>
        <span class="body-1">?</span>
      </VCardText>
      <VCardActions class="px-0 pb-0 pt-4">
        <div class="d-flex align-center justify-content-between w-100">
          <div class="w-50 pr-2">
            <VBtn
              v-blur
              class="w-100 body-2 border-radius-8"
              outlined
              large
              color="textTertiary"
              @click="closeDialog"
            >
               <span class="button">
                {{ $t('checkout.anotherPersonDetails.noKeepIt') }}
                </span>
            </VBtn>
          </div>
          <div class="w-50 pl-2">
            <VBtn
              v-blur
              class="w-100 body-2 border-radius-8"
              dark
              large
              color="error"
              @click="updateAnotherPassengerList"
            >
               <span class="button">
                {{ $t('checkout.anotherPersonDetails.yesProceed') }}
                </span>
            </VBtn>
          </div>
        </div>
      </VCardActions>
   </VCard>
</VDialog>
</template>

<script lang="ts">
export default {
  name: 'AnotherPassengerDialogDelete',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import SUserService from '@slg/web-customer-shared/src/services/UserService';
import { useGlobalErrorDialog } from '../../../../composables';

const props = defineProps({
  newAnotherPassengersList: {
    type: Array,
    default: () => [],
  },
  isAnotherPassengerDialogDeleteShow: {
    type: Boolean,
    default: false,
  },
  anotherPassenger: {
    type: Object,
    default: () => null,
  },
});

const emit = defineEmits(['populateUserProfileInfo', 'closeDeleteDialog']);

const { setGlobalError } = useGlobalErrorDialog();

const isLoading = ref(false);

const getPassengerInfo = computed(() => {
  const { firstName, lastName, phone } = props.anotherPassenger;
  return `${firstName} ${lastName} (${phone})`;
});

async function updateAnotherPassengerList() {
  isLoading.value = true;
  try {
    await SUserService.updateProfile({ anotherPassengerList: props.newAnotherPassengersList });
    emit('populateUserProfileInfo');
  } catch (e) {
    if (e.status !== 401) {
      await setGlobalError(e);
    }
  }
  isLoading.value = false;
  emit('closeDeleteDialog', true);
}

function closeDialog() {
  emit('closeDeleteDialog', false);
}
</script>
